module.exports = __webpack_public_path__ + "img/logo.b2432af8.png";